import React, { useEffect } from "react";
import Erpbanner from "./Erpbanner";
import Erpsolution from "./Erpsolution";
import Erpfeatures from "./Erpfeatures";
import Erpcards from "./Erpcards";
import Webbanner from "./Webbanner";

const Erp = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
        <Erpbanner/>
      
      <Erpsolution/>

      <Erpfeatures/>
      <Erpcards/>
    </div>
  );
};

export default Erp;
